import { useTranslation } from 'react-i18next'
import { messagingGroupsApi } from '~/apis/messagingGroupsApi'
import { useUserState } from '~/atoms/UserState'
import { toaster } from '~/components/ui/toaster'
import { ApplicationRoutes } from '~/types/RoutingTypes'
import { getUserRoleClassification } from '~/utils/auth'

import { MessagingListPage } from '@mangovoice/messaging-ui'

export const MessagingGroupsPage = () => {
  const { t } = useTranslation()
  const { pbxId, userRoles } = useUserState({ canAutoRefresh: false })

  // Mirror legacy admin's `user_can(..., MESSAGING, ...)` gate:
  // legacy's can_new and can_delete are only granted to internal_administrator
  // (Mango staff / superusers). No customer-facing role — not even Super
  // Administrator — can create or delete message groups. This is the billing
  // safeguard against end-user-initiated per-seat SMS growth. Editing of
  // existing groups (including member management) is gated on the detail
  // page.
  const { isMangoStaff, isSuperuser } = getUserRoleClassification(userRoles)
  const isInternalStaff = isMangoStaff || isSuperuser

  const getDetailPath = (groupId: number) =>
    ApplicationRoutes.MESSAGING_GROUP_DETAIL.replace(
      ':groupId',
      String(groupId),
    )

  if (!pbxId) {
    return null
  }

  return (
    <MessagingListPage
      api={messagingGroupsApi}
      pbxId={pbxId}
      toast={toaster}
      getDetailPath={getDetailPath}
      canCreate={isInternalStaff}
      canDelete={isInternalStaff}
      t={t}
    />
  )
}
